let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7l2yo")).then(() => parcelRequire('g8JDX'));